import React, { useContext, useEffect, useState } from "react";
import { Map1Set } from "../App";
import {
  blankmap,
  oldmap,
  oldphoto,
  palemap,
  photo,
  stdmap,
} from "../cesiumsetting";

export const ButtonMaps = () => {
  const { map1set, setMap1Set } = useContext(Map1Set);
  const [mapvalue, setMapvalue] = useState("");

  let maps = [
    ["標準地図", stdmap],
    ["写真", photo],
    ["淡色地図", palemap],
    ["白地図", blankmap],
    // ["English Map",engmap],
    ["古写真", oldphoto],
    ["古地図", oldmap],
  ];

  useEffect(() => {
    {
      maps.map((item) => {
        if (mapvalue == item[0]) {
          setMap1Set(item[1]);
        }
      });
    }
  }, [mapvalue]);

  const handleChange = (e) => {
    {
      maps.map((item) => {
        if (e.target.id == item[0]) {
          setMapvalue(e.target.id);
        }
      });
    }
  };

  return (
    <>
      <main className="flex md:my-3 md:mx-2 items-center justify-center pointer-events-auto">
        <div
          className="flex md:rounded-xl bg-gray-200 p-1 md:py-1"
          x-data="app"
        >
          {maps.map((item) => {
            return (
              <div key={item[0]}>
                <input
                  name="map1set"
                  id={item[0]}
                  type="radio"
                  // value={item[0]}
                  onChange={handleChange}
                  checked={item[0] == mapvalue}
                  className="peer hidden"
                />
                <label
                  htmlFor={item[0]}
                  className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white"
                >
                  {item[0]}
                </label>
              </div>
            );
          })}
        </div>
      </main>
    </>
  );
};
